<template>
  <div class="flex flex-col flex-1 absolute inset-0">
    <h2 class="text-lg font-bold mb-4">SmartInfiniteCursorScroll Demo</h2>
    <div class="flex-1 bg-red-500">
      <SmartInfiniteCursorScroll
        :loadMethod="mockLoadMethod"
        :pageSize="10"
        :distance="100"
        :queryType="'server'"
        :listField="'list'"
        :loadingText="'加载中...'"
        :finishedText="'没有更多了'"
        :emptyText="'暂无数据'"
        itemClass="border-b py-2"
        ref="scrollRef"
      >
        <template #default="{ item, index }">
          <div class="flex items-center gap-4">
            <span class="font-mono text-gray-600">#{{ index + 1 }}</span>
            <span>{{ item.name }}</span>
          </div>
        </template>
      </SmartInfiniteCursorScroll>
    </div>
    <div class="mt-4 flex gap-2">
      <el-button @click="refresh">手动刷新</el-button>
      <el-button @click="loadMore">手动加载更多</el-button>
    </div>
  </div>
</template>

<script>
import SmartInfiniteCursorScroll from "./SmartInfiniteCursorScroll.vue";

function mockData(page, pageSize) {
  const total = 35;
  const start = (page - 1) * pageSize;
  const end = Math.min(start + pageSize, total);
  const list = [];
  for (let i = start; i < end; i++) {
    list.push({ id: i + 1, name: `测试数据 ${i + 1}` });
  }
  return {
    list,
    has_more: end < total,
    next_cursor: end < total ? String(end) : "",
  };
}

export default {
  name: "SmartInfiniteCursorScrollDemo",
  components: { SmartInfiniteCursorScroll },
  data() {
    return {
      failOnce: true,
    };
  },
  methods: {
    async mockLoadMethod(params) {
      // 第一次请求故意抛出错误，后续正常
      if (this.failOnce) {
        this.failOnce = false;
        await new Promise((r) => setTimeout(r, 500));
        throw new Error("模拟第一次失败");
      }
      const page = params.page || 1;
      const pageSize = params.page_size || 10;
      await new Promise((r) => setTimeout(r, 500));
      return mockData(page, pageSize);
    },
    refresh() {
      this.$refs.scrollRef.refresh();
    },
    loadMore() {
      this.$refs.scrollRef.loadMore();
    },
  },
};
</script>
